import React, { useState } from "react";
import { Form, Input, Button, Card, notification } from "antd";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import auth from "../../services/auth";
import {
  ArrowLeftOutlined,
  HomeFilled,
  Loading3QuartersOutlined,
  LoginOutlined,
} from "@ant-design/icons";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { token } = useParams();
  const navigate = useNavigate();
  // Get email from query string
  const params = new URLSearchParams(location.search);
  const email = params.get("email") || "";

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await auth.resetPassword(token, {
        password: values.password,
        password_confirmation: values.password_confirmed,
        email,
      });
      notification.success({
        message: "Password Reset",
        description: "Your password has been reset successfully.",
      });
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    } catch (error) {
      notification.error({
        message: error?.message || "Error",
        description:
          error?.response?.data?.message || "Failed to reset password.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card title="Reset Password" style={{ width: 400 }}>
        <Form layout="vertical" onFinish={onFinish}>
          {/* token is now from URL param, no need for hidden field */}
          <Form.Item name="email" initialValue={email} hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item
            name="password"
            label="New Password"
            rules={[
              { required: true, message: "Please enter your new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
          >
            <Input.Password placeholder="Enter new password" size="large" />
          </Form.Item>
          <Form.Item
            name="password_confirmed"
            label="Confirm Password"
            dependencies={["password"]}
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" size="large" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Reset Password
            </Button>
          </Form.Item>
        </Form>
        <Button
          type="link"
          icon={<LoginOutlined />}
          style={{ margin: "16px 0 0 -8px", paddingLeft: 0 }}
          onClick={() => navigate("/login")}
        >
          Login
        </Button>
      </Card>
    </div>
  );
};

export default ResetPassword;
